var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-qr',{attrs:{"text":_vm.downloadData.url,"margin":10,"colorDark":"#000","colorLight":"#fff","dotScale":1,"logoSrc":_vm.downloadData.icon,"logoScale":0.2,"size":200}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }